import React from 'react';
import { PropTypes } from 'prop-types';
import { selectCurrentData } from '../App/selectors';

import { connect }  from 'react-redux';
import { COLOR } from '../App/constants';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import { platformHandler } from '../platforms/PlatformHandler'
import { languageManager } from '../utils/languageManager'
import { setSelectedPPT, setSharePPT, openConfig, setStateLoadingPresentation} from '../App/actions'

import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';

import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import CloseIcon from '@material-ui/icons/Close';


import {KeyboardArrowRight,Edit,CloudUpload} from '@material-ui/icons';

import FwSlideListSelectionItem from '../components/FwSlideListSelectionItem'
import {FwScene} from './FwScene'
import FwSlideConfigDialog from '../components/FwSlideConfigDialog';
import FwModalLoader from '../components/FwModalLoader';

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

import openFolderImg from '../assets/openFolder.png'

import { Steps,Hints } from '../third/intro.js-react';
import '../third/intro.js/introjs.css';

const styles = theme => ({  

	divOpen: {
		cursor: 'pointer',
		display:'flex',
		alignItems:'center',
		marginTop:16,			
		height:0,
	},

	openFolderImg: {
		marginRight:16,
	},

	divStepper: {
		width: "90%",
	},

	stepper: {
		backgroundColor: "transparent",
	},

	stepperIconActive: { // define styles for icon container    		
    	color: 'cornflowerblue !important',
  	},

	flipwitContent: {
	    height:'calc( 100% - 64px )',
	    display: 'flex',    
	    justifyContent: 'flex-start',
	    alignItems: 'center',
	    flexWrap: 'nowrap',    
	    flexDirection: 'column',     
	    width: '100%',
	    overflow: "auto",
	    minWidth: "1060px",
	    position: "absolute",
	    top: "64px",
	    left: "0px",
	},  

	divColumnns: {
		display: "flex",
    	width: "90%",
    	height: "80%",
	},

	paperTitle: {
		backgroundColor: 'darkgray',//COLOR.FLIPWIT_COLOR_2',
		color: 'black',
		//height: 48,
		minHeight: 48,
		display: "flex",
		justifyContent: "flex-start",
		//display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%',		
	}, 
	paperSubTitle: {
		color: 'black',
		fontFamily: 'Roboto-Regular',
		margin: theme.spacing.unit * 3,
		textAlign: "center",
	},
	paper: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		//height: '50%',
		//maxHeight: 320,
		maxWidth: 1300,
		//minHeight: 300,
		height: '100%',
		flex: 5,		
		minWidth: 230,    
		minHeight:200,
		//padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
	},

	labelTitlePaper: {
		display: 'flex',
		alignItems: 'inherit',
		fontSize: '1.3em',	
		fontFamily: 'Roboto-Medium',	
		//margin: (theme.spacing.unit*2)+"px "+(theme.spacing.unit*2)+'px',
	},

	arrowDiv: {
		flex: 1,
	},

	arrowIcon: {
		fontSize: "64px",
    	color: "gray",
	},

	actionIcon: {
		fontSize: "32px",
    	marginRight: (theme.spacing.unit/2),
	},


	labelDescPaper: {
		alignSelf: 'self-start',
		margin: theme.spacing.unit*3,
	},

	actionButton: {
		padding: "12px 24px",		
	},

	actionButton2: {
		padding: "12px 24px",		
	},

	actionButtonInactive: {
		backgroundColor: "gray",
		pointerEvents: "none",				
	},

	inactiveDiv: {
		pointerEvents: "none",
	},

	buttonOmit: {
		display: 'flex',
		alignItems: 'inherit',
		fontSize: '1.1em',
		color: '#50738F',
		textTransform: 'none',
		textDecoration: 'underline',
	},

	buttonOmitInactive: {
		color: 'gray',	
		pointerEvents: "none",	
	},

	divider: {
		border: "1px solid gray",
    	width: "80%",
    	margin: theme.spacing.unit*6,
	},

	listSlides: {
		width: '95%',	    
		backgroundColor: theme.palette.background.paper,
		position: 'relative',
		overflowX: 'hidden',	    
		overflowY: 'auto',
		border: '2px solid #CCC',
		marginBottom: 24,
		paddingTop: 0,
		//minHeight: 165,
		height: "100%",
	},
	loaderContainer: {
		flex: 1,
		flexDirection: 'column',
		display: 'flex',
		justifyContent: 'center',
		transform: 'translateY('+(-24)+'px)',
	},
	titleUpload: {
		fontWeight: "700",
		margin: "24px",
		textAlign: "center",
		marginTop: "0px",
	},
	descUpload: {
		margin: "24px",
    	textAlign: "center",
    	lineHeight: "2em",
    	whiteSpace: "pre-wrap",
	},
	divLastStep: {
	    display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
	},
	savePart: {
		display: "flex",
    	flexDirection: "column",    
    	alignItems: "center",
	},
	uploadPart : {
		padding: "10px",
    	width: "100%",
    	height: 200,
	},

	fab: {
	    right: "14px",
	    bottom: "0px",
	    margin: "8px",
	    position: "absolute",
	    backgroundColor: "#0007",
	    //height: "10px",
	    '&:hover': {
	      backgroundColor: "#000A",
	    }  
	}, 
	extendedIcon: {
	    marginRight: theme.spacing.unit,
	},

	divOmit: {
		display: "flex",
    	flexDirection: "column",
    	alignItems: "center",
	},
});

/*const steps = [
	        {
	          element: '#column_avaliable_slides',
	          intro: 'Abre en PowerPoint una presentación guardada en tú computador para continuar',
	        },
	        {
	          element: '.listPPTs',
	          intro: 'Flipwit identificará todas las presentaciones de PowerPoint Abiertas, selecciona una para continuar',
	        },
	        {
	          element: '#column_edition',
	          	intro: 'Para continuar presiona EDITAR y asi crear diapositivas especiales (preguntas, videos de youtube, entre otros). O presiona Omitir si no deseas agregar diapositivas.',
	        },
	        {
	        	element: '#savePart',
				intro: 'Guarda la presentación para tener acceso desde cualquier dispositivo.',
	        },
	        {
	        	element: '#uploadPart',
				intro: 'Una vez guardes tu presentación, entra en nuestra aplicación web www.fwtap.com para iniciar la presentación interactiva.',	        	
	        },
	      ];*/

class UploadPresentation extends FwScene {
	state = {
		selected: -1,
		nameSelected: '',
		showDialog:true,
		isLan: false,	
		showModalLoader: false,	
		cloudExpanded: '',
		localExpanded: '',
		filePDF: '',
    	page: 0,
    	currentStep: 0,
    	stepsEnabled: true,
		currentTutorialStep: 0,
		showTutorial: false,

		hintsEnabled: true,
		hints: [
			{
			  element: '.hello',
			  hint: 'Hello hint',
			  hintPosition: 'middle-right',
			}
		],

		showLoader: false,
	}

	constructor(props) {
		super(props);
				
		this.showTutorial = false;
		this.elementsPCString = [];

		if(!platformHandler.getUserConfig("tutorial_select_presentation_finished")) {
			platformHandler.setUserConfig("tutorial_select_presentation_started",true);
			this.showTutorial = true;
		}
	}

	componentDidMount(){

		console.log("entra a Uploadpresentation con ", this.props.location.state.shouldReportCurrentScreenChange)			
		platformHandler.checkTitleBarScene("UploadPresentation");
		
		platformHandler.getPptsOpen();

		//Si cuando monta el componente ya el reducer tiene un slideName es porque es volver de una edicion de PPT
		//por esta razon el currentStep automaticamente es 2 para que la pueda subir
		if(this.props.slideName!=="") {
			this.setState({currentStep: 2,nameSelected:this.props.slideName})

			console.log('Recuperar',this.state.showTutorial);

			//Si volvio de la edición y estaba en tutorial, activa el proximo
			if(this.showTutorial) {
				if(this.introJsStepObj) this.introJsStepObj.manualGoto(3);
				this.setState({showTutorial:true,currentTutorialStep:3});				
			}	
		}

		/*if( ! platformHandler.isLocalSession ){
			platformHandler.getPptsCloud();
		}*/

		/*let textTemp = languageManager.getLangWord("STATES_INIT_PRESENTATION." + 0);
        textTemp += ("\n" + 11 + " / " + 23 );              
      	platformHandler.dispatch( setStateLoadingPresentation( textTemp));*/
	}

	onSlideItemSelected = (id,nameSelected) => {

		console.log('Selecciona el ',id,nameSelected);

		//Si el paso actual (columna) es 0 entonces pasa al siguiente paso, pero jamas 
		//lo cambia si ya voy en un paso mas adelante
		let newStep = this.state.currentStep==0?1:this.state.currentStep;

		//A no ser de que haya seleccionado otro ppt, en ese caso si reinicia el paso
		if(nameSelected!==this.state.nameSelected) {
			newStep = 1;
		}
		
		this.props.dispatch( setSelectedPPT( nameSelected, false ));
		this.setState({selected:id,currentStep:newStep,nameSelected,uploadingPPT:false});

		//Si estoy mostrando el tutorial y estoy en el paso 1 entonces continuo pues ya se 
		//seleccionó un PPT
		if(this.state.showTutorial) {
			if(this.state.currentTutorialStep===1) {
				this.introJsStepObj.manualNext();
				this.setState({currentTutorialStep:2});
			}
		}		
	};

	editButtonClick = () => {
		platformHandler.presentationSelected( this.state.nameSelected, false, '' );	
	}

	onButtonPress( index ){
	    this.setState({ selected: index, isLan: index < this.props.currentData.localPPTs.length }) 
	};

	closeDialog(  ){
	    this.setState({ showDialog:false }) 
	};

	onSelectPress( ){
		if( this.state.selected !== -1 ){
			let currentData = this.props.currentData;
			let isCloud = this.state.selected >= currentData.localPPTs.length;
			let indexPPT = this.state.selected;
			let namePPT = "";
			let idCloud = "";
			if( isCloud ){
				indexPPT = this.state.selected - currentData.localPPTs.length;
				namePPT = currentData.cloudPPTs[indexPPT].name;
				idCloud = currentData.cloudPPTs[indexPPT].id;
			}else{
				namePPT = currentData.localPPTs[indexPPT];
			} 

			platformHandler.presentationSelected( namePPT, isCloud, idCloud )
		}
		
	};

	renderOption( isCloud, listValue, i ){
		if( isCloud ){
			if( this.props.currentData.localPPTs.indexOf(listValue.name) !== -1 ){
				return null;
			}
		}
		//let index = isCloud?this.props.currentData.localPPTs.length+i:i;
		this.iteratorCloud ++;
		/*return <OptionPPT 
					key={index} 
					textValue={isCloud?listValue.name:listValue} 
					isPair={this.iteratorCloud%2==0}
					index={index} 
					active={this.state.selected == index}
					onItemPressed={this.onButtonPress.bind(this)}
				/>*/
		return null;
	}

	configReceivedFromServer = (data) => {
		console.log('llega la config ', data)
		this.setState({showModalLoader:false})

		if( data.config ) {

			if( data.config.shareFinish !== undefined && data.config.shareFinish !== null){
				console.log('>>> La setea en ' , data.config.shareFinish)
	      		this.props.dispatch( setSharePPT( data.config ) )
	      	}
	      	else {
	      		this.props.dispatch( setSharePPT( false ) )	
	      		//this.sceneManager.openScene("MainMenu", {config: data.config} );
	      	}
	    }
	    else{
	      //this.sceneManager.openScene("MainMenu", {config: "{}"} );
	    }

	    this.props.dispatch( openConfig( ) );
	} 

	onSlideItemClick = (idSelected,action,cloudObject,slideName) => {

		console.log(this)
		
		//Si cloudObject es nulo, entonces no es un item de la nube
		let isCloud = cloudObject!==undefined && cloudObject!==null;
		let idCloud = isCloud?cloudObject.id:'';
		let namePPT = isCloud?cloudObject.name:slideName;

		console.log('namePPT ' + namePPT)

		switch(action) {
			case "conf": 	this.props.dispatch( setSelectedPPT( namePPT, isCloud ));
							platformHandler.checkConfigSlides(namePPT,this.configReceivedFromServer);
							this.setState({showModalLoader:true})
							break;

			case "play": 	console.log("start", namePPT, isCloud, idCloud );

							if( !isCloud ){
								const result = this.props.cloudPPTs.find( ppt => ppt.name === namePPT );
								
								if( result ){
									isCloud = true;
									idCloud = result.id;
								}
								else{
									this.openModal({title:languageManager.getLangWord("FIRST_UPLOAD_TITLE"),message: languageManager.getLangWord("FIRST_UPLOAD_DESC")})      
									return;
								}
							}
							
							//const resultado = 

							platformHandler.presentationStarted( namePPT, isCloud, idCloud );
							//platformHandler.openScene("PresentationMode");
							break;

			case "edit": 	platformHandler.presentationSelected( namePPT, isCloud, idCloud );							
							break;

			case "upload": 	
							this.props.dispatch( setSelectedPPT( namePPT, isCloud ));
							this.setState({ uploadingPPT:true })
							platformHandler.uploadPPT( this.cbUpload );
				break;

			case "delete": 	this.openModal({title:languageManager.getLangWord("CONFIRMATION"),message: languageManager.getLangWord("CONFIRMATION_DELETE")
        					,buttons: [{label:languageManager.getLangWord("YES"),callback:() => this.deleteSlides(namePPT)},{label:languageManager.getLangWord("NO")}]}) 
				break;

			default:
		}
	}

	saveData = () => {

	  if(this.canvasElement==null)
	  {
	    let divCanvasContainer = document.getElementById("canvasContainer_fw_to_export");
	    if(divCanvasContainer==undefined) return;

	    for (var i = divCanvasContainer.children.length - 1; i >= 0; i--) {
	      if(divCanvasContainer.children[i].localName == "canvas") {
	        this.canvasElement = divCanvasContainer.children[i];
	        window.canv = this.canvasElement;
	        break;
	      }
	    }
	  }

	  try
	  {
	    let downloadURL = this.canvasElement.toDataURL('image/jpeg');//.replace("image/jpeg", "image/octet-stream");
	    downloadURL = downloadURL.substring(downloadURL.indexOf(',')+1)
	    //console.log(downloadURL)

	    platformHandler.FlipwitSlideConnector.savePreview( downloadURL,this.state.page);

	    this.setState( { page: this.state.page + 1 });
	    this.renderPage();
	  }
	  catch(e) {
	    console.log('hubo error en 2',e)
	  }
	}

	renderPage = () =>{
	  // Get the first page.
	  console.log('pide la ' + this.state.page)
	  if(this.state.page>this.state.pages){
	    platformHandler.FlipwitSlideConnector.pdfToImagesFinished();
	  }
	  else{
	    platformHandler.setStateInitPresentation(0, this.state.page);
	    const { canvas } = this;
	    this.pdfDocument.getPage(this.state.page).then( (page) => {
	      // Render the page on a Node canvas with 100% scale.
	      var viewport = page.getViewport(1.0);

	      const canvasContext = canvas.getContext('2d');
	      canvas.height = viewport.height;
	      canvas.width = viewport.width;

	      const renderContext = {
	        canvasContext,
	        viewport,
	      };
	      page.render(renderContext).then( () => { this.saveData() })
	    });
	  }

	}

	cbUpload = ( state, isWin ) =>{
		console.log('state', state, isWin)
		if( state.error ){
			this.setState({ uploadingPPT:false });
			this.openModal({title:languageManager.getLangWord("FIRST_UPLOAD_TITLE"),message: languageManager.getLangWord("ERROR_SAVING")})
			return;
		}


	    if( !isWin ){
	      var pdfjsLib = require('pdfjs-dist');
	      var fs = window.require('fs');

	      pdfjsLib.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/build/pdf.worker')

	      // Relative path of the PDF file.
	      var pdfURL = state.path;
	      console.log('rud ' + pdfURL)

	      // Read the PDF file into a typed array so PDF.js can load it.
	      var rawData = new Uint8Array(fs.readFileSync(pdfURL));

	      // Load the PDF file.
	      pdfjsLib.getDocument(rawData).then( (pdfDocument) => {
	        this.pdfDocument = pdfDocument;
	        console.log('# PDF document loaded.');

	        this.setState({ completed:true, page: 1, pages: pdfDocument.numPages });
	        this.renderPage();
	      });

	      this.setState({ filePDF:state.path });
	    }
	}

	colocarEstadoTutorial(step) {
		
		console.log('Quiere poner el TUTO ',step," y tiene",this.state.currentTutorialStep,"show",this.state.showTutorial);

		//Si ya esta en el estado al que va entonces no hace nada, a no ser de que aun no se
		//este mostrando el tutorial
		if(step===this.state.currentTutorialStep && this.state.showTutorial) {
			return false;
		}	

		if(step>=0) {
			if(this.introJsStepObj) {
				this.introJsStepObj.manualGoto(step+1);
			}
			
			this.setState({showTutorial:true,currentTutorialStep:step});			
		}
		else {
			this.setState({showTutorial:false,currentTutorialStep:0});			
		}
		
		return true;
	}

	/*
		Funcion para colocar el cambio en el tutorial intro.js según el estado de la pantalla
		retorna true si hay un cambio en el tutorial y false si no lo hay.
	 */
	processTutorialStep(elements,anySelected) {
		
		//Sio no deberia haber tutorial se sale
		if(!this.showTutorial) return false;

		//Si no hay elementos va al estado 0
		if(elements.length===0) {
			return this.colocarEstadoTutorial(0);
		}

		//Si hay elementos pero no hay ninguno seleccionado entonces va al 1
		if(elements.length>0 && !anySelected) {
			return this.colocarEstadoTutorial(1);
		}

		//Si esta en el primer paso pero ya hay al menos un elemento, va al siguiente
		if(this.state.currentTutorialStep===0 && elements.length>0) {
			return this.colocarEstadoTutorial(1);
		}

		//Si esta en el segundo paso y ya hay uno seleccionado, va al siguiente
		if(this.state.currentTutorialStep===1 && anySelected) {
			return this.colocarEstadoTutorial(2);
		}

		return false;
	}

	processPPTsPCList() {
		var elements = [];
		var idSelected = -1;
		var elementsString = [];

		console.log('Reinit datos',this.props.slideName,'>',this.state.nameSelected);

		//Agrega los elementos de PowerPoint abiertos
		this.props.localPPTs.forEach((pptName) => {
			if(this.state.nameSelected===pptName) idSelected = elements.length;
			//if(this.props.slideName===pptName || this.state.nameSelected===pptName) idSelected = elements.length;
			elementsString.push(pptName);
			elements.push(
				<FwSlideListSelectionItem openedObj={this.getLocalExpanded} key={'Item'+elements.length} id={elements.length} onSlideItemSelected={this.onSlideItemSelected} slideName={pptName} idSelected={idSelected}/>
			)
		});

		if(idSelected===-1 && this.state.nameSelected!=="") {
			this.setState({nameSelected:""});
			platformHandler.presentationSelected( '', false, '' );
			return;
		}

		if(this.processTutorialStep(elements,idSelected!==-1)) return;

		/*console.log('Estado',this.state,this.showTutorial,this.firstListProcessed,this.state.currentTutorialStep,elements.length,this);
		console.log('Solo<',this.showTutorial,this['showTutorial'],'>');

		//Si estoy mostrando el tutorial y estoy en el paso 0 y ya se abrio al menos un 
		//ppt entonces lo pasa para el paso 1
		if(this.showTutorial) {
			if(this.state.currentTutorialStep===0 && elements.length>0) {
				console.log('PREV Tutorial en',this.state.currentTutorialStep,this.state.showTutorial);
				
				if(this.introJsStepObj) this.introJsStepObj.manualGoto(2);
				//Si ya estaba en el 3 es porque estaba regresando de una edición
				if(this.state.currentTutorialStep<3)this.setState({showTutorial:true,currentTutorialStep:1});
			}
		}

		if(!this.firstListProcessed) {
			if(this.showTutorial) {
				if(elements.length===0) {
					//Si ya estaba en el 3 es porque estaba regresando de una edición
					if(this.state.currentTutorialStep<3) this.setState({showTutorial:true,currentTutorialStep:0});
				}
				else {
					console.log('Coloca el tutorial como paso 1',elements.length);
					//Si ya estaba en el 3 es porque estaba regresando de una edición
					if(this.state.currentTutorialStep<3) this.setState({showTutorial:true,currentTutorialStep:1});
				}
			}
		}*/

		//Si no hay elementos o hay pero ninguno está seleccionado y va en un paso mas adelante es porque
		//ya estaba avanzado y se cerro el PPT entonces todo se reinicia.
		if((elements.length===0 || idSelected===-1) && this.state.currentStep>0) {
			this.setState({currentStep:0});			
		}

		//Si no hay ninguna presentación entonces muestra un mensaje de ayuda
		if(elements.length===0) {
			elementsString.push("elementoAyudaFl");
			elements.push(
				<FwSlideListSelectionItem key={'OnlyItem'} id={elements.length} slideName={languageManager.getLangWord('NOPPTSOPEN')} helpItem />
			)
		}

		if(!this.equalArrayString(elementsString,this.elementsPCString)) {
			this.elementsPCString = elementsString;

			if(this.state.showLoader) {
				this.setState({showLoader:false});
				window.require('electron').remote.app.bringToFront();				
			}
		}

		return elements;	
	}

	equalArrayString = (arr1,arr2) => {		
		if(arr1.length!==arr2.length) return false;

		for (var i = arr1.length - 1; i >= 0; i--) {
			if(!arr2.includes(arr1[i])) return false;			
		}

		return true;
	}

	optionDialogStartPPT= ( value ) => {
		if( value ){
			platformHandler.presentationStarted( platformHandler.getPPTName(), true, platformHandler.cloudPresentationID );
		}
		else{
			this.setState({ uploadingPPT:false })
		}
	}

	processStrong = function(str) {

		if(str===undefined) return "undefined";

		let indexF = str.indexOf("<strong>");

		console.log('index',indexF);

		if(indexF!==-1) {
			let indexFinal = str.indexOf("</strong>");

			console.log('indexFinal',indexFinal);

			let part1 = str.substring(0,indexF);
			let partMid = str.substring(indexF+8,indexFinal);
			let part2 = str.substring(indexFinal+9);

			return (<React.Fragment>
					{part1} 
					<strong> {partMid} </strong> 
					{part2}
					</React.Fragment>);
		}

		return str;
	}

	getDialogUpload = () =>{
		const { classes } = this.props;

		if( this.state.uploadingPPT ){
			if ( this.props.stateLoadingPresentation ) {

				return (<div>
					<div className={classes.titleUpload}>
						{languageManager.getLangWord("UPLOADING")}
					</div>
					<div className={classes.descUpload}>
						{this.props.stateLoadingPresentation}
					</div>
				</div>);				
			}
			else{
				return (<div className={classes.divLastStep}>
					<div className={classes.titleUpload}>
						{languageManager.getLangWord("STATES_INIT_PRESENTATION.2")}
					</div>
					<div className={classes.descUpload} style={{lineHeight: 1,marginTop:0}}>
						{this.processStrong(languageManager.getLangWord("STATES_INIT_PRESENTATION.FINISH"))}
					</div>
					<Button variant="contained" color="secondary" className={classNames(classes.actionButton)} onClick={this.openWebApp}>
	              		{languageManager.getLangWord('GO_TO_FWTAP')}
	              	</Button>	
				</div>);				
			}
		}
		else{
			return null;
		}
	}

	openWebApp = () => {

		var url = "https://www.fwtap.com/";


		if(this.showTutorial) {
			//Indica que ya terminó el tutorial a la configuración del usuario
			platformHandler.setUserConfig("tutorial_select_presentation_finished",true);
			this.showTutorial = false;
			this.setState({showTutorial:false,currentTutorialStep:0});			
			url+="t=true";
		}
		
		platformHandler.openExternalURL(url);
	}

	openPptExplorer = () => {
		this.setState({showLoader:true});

		window.require('electron').remote.app.openFileDialog((data) => {
			console.log('Llega con data',data);
			//Quita el loader si llega undefined porque significa que al dialogo de 
			//abrir PPT se le dio cancelar, si llega un objeto es porque si se dio abrir
			//entonces no se quita hasta que no se abre el PPT, que al hacerse se invoca de 
			//nuevo processPPTsPCList y el lo cierra al final de la función
			if(data===undefined) {
				this.setState({showLoader:false});
			}
			//Si le dio que abriera un archivo, pero ese ya estaba en la lista entonces quita el loader, porque 
			//si no se quedaria bloqueado pues nunca va a cambiar la lista de abiertos
			else {
				var lastSl = data.lastIndexOf('/');
				var lastBl = data.lastIndexOf('\\');
				var lastToUse = lastBl>lastSl?lastBl:lastSl;
				var filename = data.substr(lastToUse+1);

				if(this.elementsPCString.includes(filename)) {
					this.setState({showLoader:false});
				}
			}
		});
	}
	
	getSteps = () => {
  		return ['UPLOADCOLUMNS.STEPTITLES.COLUMN1', 'UPLOADCOLUMNS.STEPTITLES.COLUMN2', 'UPLOADCOLUMNS.STEPTITLES.COLUMN3'];
	}

	gotoFinalStep = () => {		
		if(this.state.showTutorial) {
			if(this.state.currentTutorialStep===2) {
				this.setState({currentStep:2});
				this.colocarEstadoTutorial(3);
				return;
			}
		}	

		this.setState({currentStep:2});
	}

	uploadSelected = () => {

		console.log('Colocar selected PPT como ',this.state.nameSelected);
		this.props.dispatch( setSelectedPPT( this.state.nameSelected, false ));
		this.setState({ uploadingPPT:true })
		platformHandler.uploadPPT( this.cbUpload );

		//Si volvio de la edición y estaba en tutorial, activa el proximo
		if(this.showTutorial) {
			if(this.introJsStepObj) this.introJsStepObj.manualGoto(5);
			this.setState({showTutorial:true,currentTutorialStep:5});				
		}
	}

	onExitIntroJS = (index) => {
		console.log('Termina el index de introJS',index);
	} 
	
	onExit = () => {};
  
  regStepsParent = (introJsStepObj) => {
  	console.log('Guarda la referencia',introJsStepObj,"en",this);
	this.introJsStepObj = introJsStepObj;
  }

  clickHelp = () => {	
  	if(this.showTutorial && this.inHelp) {
		this.inHelp = false;
		this.showTutorial = false;		
		this.colocarEstadoTutorial(-1);
  	}
  	else {
	  	this.inHelp = true;
	  	this.showTutorial = true;

	  	if(this.elementsPCString.length>0) {
	  		if(this.elementsPCString.length==1 && this.elementsPCString[0]==="elementoAyudaFl") {
	  			this.colocarEstadoTutorial(0);	
	  		}
	  		else {
	  			if(this.state.nameSelected!=="") {
	  				this.colocarEstadoTutorial(2); 		
	  			}
	  			else {
	  				this.colocarEstadoTutorial(1); 		
	  			}
	  		}
	  	}
	  	else {
	  		this.colocarEstadoTutorial(0);
	  	}
  	}	
  }

	render() {

		console.log('Renderiza en upload');
		const { stepsEnabled, currentTutorialStep, hintsEnabled, hints } = this.state;

		const { classes } = this.props;
		const { currentStep } = this.state;

		const stepsPPT = this.getSteps();


		//console.log("props ", this.props)
		//const {currentData} = this.props;

		this.iteratorCloud = 0;
		
		var showLoader = true;

		var elementsPC = [];
		var elementsCloud = [];

		console.log('Ejecuta render',this.props.localPPTs);

		//Si ya se cargaron los slides locales
		if(this.props.localPPTs!==undefined && this.props.localPPTs!==null) {
			/*//Si no es una sesion local debe mirar si ya llegaron las diapositivas que hay en la nube
			if( platformHandler.isLocalSession || (this.props.cloudPPTs!==undefined && this.props.cloudPPTs!==null)){*/
				var showLoader = false;
				elementsPC = this.processPPTsPCList();
			console.log('Recargar la lista');
				/*elementsCloud = this.processPPTsCloudList();				
			}*/
		}

		
		console.log('state uploadint', this.props.stateLoadingPresentation)

		var noLocalPPTs = this.props.localPPTs==null || this.props.localPPTs.length==0;

		console.log('Tutorial en paso ',currentTutorialStep,'con show-> ',this.state.showTutorial );

		var disableButtonForUpload = (this.state.uploadingPPT && this.props.stateLoadingPresentation)?classes.actionButtonInactive:undefined;

		const steps = [
	        {
	          element: '#column_avaliable_slides',
	          intro: languageManager.getLangWord('PC_TUTORIAL_STEP0'),
	        },
	        {
	          element: '.listPPTs',
	          intro: languageManager.getLangWord('PC_TUTORIAL_STEP1'),
	        },
	        {
	          element: '#div_omit',
	          intro: languageManager.getLangWord('PC_TUTORIAL_STEP2'),
	        },
	        {
	        	element: '#savePart',
				intro: languageManager.getLangWord('PC_TUTORIAL_STEP3'),
	        },
	        {
	        	element: '#uploadPart',
				intro: languageManager.getLangWord('PC_TUTORIAL_STEP4'),
	        },
	    ];

		var tutorial = <div>
				<Steps
		          enabled={stepsEnabled}
		          steps={steps}
		          initialStep={currentTutorialStep}
		          onExit={this.onExit}
		          regParent={this.regStepsParent}
		          options={{
		          	showBullets:false,
		          	keyboardNavigation:false,
		          	showButtons:false,
		          	exitOnOverlayClick:false,
		          	exitOnEsc:false,
		          }}
		        />
		        {/*<Hints
		          enabled={hintsEnabled}
		          hints={hints}
		        />
		        <div className="controls">
		          <div>
		            <button onClick={this.toggleSteps}>Toggle Steps</button>
		            <button onClick={this.addStep}>Add Step</button>
		          </div>
		          <div>
		            <button onClick={this.toggleHints}>Toggle Hints</button>
		            <button onClick={this.addHint}>Add Hint</button>
		          </div>
		        </div>
		        
		        <h1 className="hello">Hello,</h1>
		        <hr />
		        <h1 className="world">World!</h1>
		        <hr />
		        <h1 className="alive">It's alive!</h1>*/}
	      </div>

	    //tutorial = null;

		return (
			<React.Fragment>
				{this.state.showLoader && <FwModalLoader text={languageManager.getLangWord('WAIT_FOR_PPT')} />}
				{this.state.showTutorial && tutorial}
				<div id="canvasContainer_fw_to_export" style={{position:'fixed',visibility:'hidden','zIndex':'0'}}>
					<canvas ref={(canvas) => { this.canvas = canvas; }} />
				</div>
				<FwSlideConfigDialog />		
				{ /*this.state.uploadingPPT && this.getDialogUpload()*/ }
				<div className={classes.flipwitContent}>
					<div className={classes.divStepper} >
						<Stepper activeStep={currentStep} className={classes.stepper}>
							{stepsPPT.map((label, index) => {
								return (
									<Step key={label} > 
										<StepLabel StepIconProps={{ 
										      classes: { active: classes.stepperIconActive, completed: classes.stepperIconActive } 
										    }}>{languageManager.getLangWord(stepsPPT[index])}
									  	</StepLabel>
		    						</Step>
								);							
							})}		            
				        </Stepper>
					</div>
					<div className={classes.divColumnns}>
						{/*
							Columna donde se selecciona el PPT
						*/}
						<Paper id="column_avaliable_slides" className={classes.paper} style={{flex:8}}>
							<div className={classes.paperTitle}>
			              		<div className={classes.labelTitlePaper}>{languageManager.getLangWord('UPLOADCOLUMNS.TITLES.COLUMN1')}</div>			              		
			            	</div>	
			            	<div className={classes.paperSubTitle}>
			              		{languageManager.getLangWord('UPLOADCOLUMNS.DESC.COLUMN1')}			              		
			            	</div>	            	
							<div className={classNames(classes.divOpen,disableButtonForUpload)} onClick={() => {
									this.openPptExplorer()
									//this.introJsStepObj.manualNext();
								}}>
			            		<img src={openFolderImg} className={classes.openFolderImg} alt="logo"/>								
				            	<Button variant="contained" color="secondary" className={classNames(classes.actionButton,disableButtonForUpload)} >
				              		{languageManager.getLangWord('OPEN')}
				              	</Button>			            		
							</div>
							
							<div className={classes.divider}></div> 

							{!showLoader &&
			            	<List id="listPPTs" className={classNames(classes.listSlides,"listPPTs",disableButtonForUpload)} onClick={() => {if(noLocalPPTs)this.openPptExplorer()}} style={noLocalPPTs ?  {cursor:'pointer'} : {}}>
			            		{elementsPC}	              
					    	</List>}
		            	</Paper>


		            	<DivArrow classes={classes} active={this.state.currentStep>=1} />

		            	{/*
							Columna donde se decide si editar el PPT
						*/}
		            	<Paper id="column_edition" className={classes.paper} >
							<div className={classes.paperTitle}>
			            		<Edit className={classes.actionIcon} style={{color:currentStep>=1?'rgba(0, 0, 0, 0.87)':'gray'}}/>								
			              		<div className={classes.labelTitlePaper} style={{color:currentStep>=1?'black':'dimgray'}}>{languageManager.getLangWord('UPLOADCOLUMNS.TITLES.COLUMN2')}</div>
			            	</div>			
			            	<div className={classes.paperSubTitle}>
			              		{languageManager.getLangWord('UPLOADCOLUMNS.DESC.COLUMN2')}			              		
			            	</div>	    
			            	<div className={classNames(classes.divOpen,currentStep<1 && classes.inactiveDiv,disableButtonForUpload)} onClick={this.editButtonClick}>
				            	<Button variant="contained" color="secondary" className={classNames(classes.actionButton,currentStep<1 && classes.actionButtonInactive,disableButtonForUpload)}>
				              		{languageManager.getLangWord('EDIT_OPTION')}
				              	</Button>			            		
							</div>   
							<div className={classes.divider}></div> 
							<div id="div_omit" className={classes.divOmit}>
								<div className={classes.paperSubTitle}>
				              		{languageManager.getLangWord('UPLOADCOLUMNS.DESC2.COLUMN2')}			              		
				            	</div>	
								<Button variant="contained" color="primary" className={classNames(classes.actionButton2,currentStep<1 && classes.actionButtonInactive,disableButtonForUpload)} onClick={this.gotoFinalStep} >{
									languageManager.getLangWord('OMIT')
								}</Button>								
							</div>
		            	</Paper>

		            	<DivArrow classes={classes} active={this.state.currentStep>=2} />

		            	{/*
							Columna donde se sube a la nube el PPT
						*/}
		            	<Paper className={classes.paper} >
							<div className={classes.paperTitle}>
			            		<CloudUpload className={classes.actionIcon} style={{color:currentStep>=2?'rgba(0, 0, 0, 0.87)':'gray'}}/>								
			              		<div className={classes.labelTitlePaper} style={{color:currentStep>=2?'black':'dimgray'}}>{languageManager.getLangWord('UPLOADCOLUMNS.TITLES.COLUMN3')}</div>
			            	</div>	
			            	<div id="savePart" className={classes.savePart}>
				            	<div className={classes.paperSubTitle}>
				              		{languageManager.getLangWord('UPLOADCOLUMNS.DESC.COLUMN3')}			              		
				            	</div>
				            	<div className={classNames(classes.divOpen,currentStep<2 && classes.inactiveDiv,disableButtonForUpload)} onClick={this.uploadSelected}>
					            	<Button variant="contained" color="secondary" className={classNames(classes.actionButton,currentStep<2 && classes.actionButtonInactive)}>
					              		{languageManager.getLangWord('SAVE_OPTION')}
					              	</Button>			            		
								</div>   			            		
								<div className={classes.divider}></div> 	
			            	</div>
			            	<div id="uploadPart" className={classes.uploadPart} >
								{ this.state.uploadingPPT && this.getDialogUpload() }										            		
			            	</div>
		            	</Paper>

					</div>					
			    </div>
			    <div>
			    	<Fab variant="extended" color="primary" aria-label="help" className={classes.fab} onClick={this.clickHelp} style={this.inHelp?{zIndex: 1000000}:{}}>
				        {this.inHelp && <CloseIcon className={classes.extendedIcon} />}
				        {!this.inHelp && <HelpOutlineIcon className={classes.extendedIcon} />}
				        <span>
		               		{this.inHelp && languageManager.getLangWord("CLOSE")}
		               		{!this.inHelp && languageManager.getLangWord("HELP")}
		               </span>	
				    </Fab>
			    </div>
			   
		    </React.Fragment>);
	}
}

class DivArrow extends React.Component {
  render() {
    const { classes } = this.props;


    let newStyle = {};

	if(this.props.active) { 
		newStyle = {color: 'cornflowerblue'}
	}
	
	console.log('La flecha ',this.props,'da',newStyle);

    return (
      <div className={classes.arrowDiv} ><KeyboardArrowRight className={classes.arrowIcon} style={newStyle}/></div>
    );
  }
}

UploadPresentation.propTypes = {
  classes: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object,  
};

UploadPresentation.contextTypes = {
  store: PropTypes.object,
};

const mapStateToProps = state => {  	
  return {
  	localPPTs: selectCurrentData(state).localPPTs,  
    cloudPPTs: selectCurrentData(state).cloudPPTs, 
    stateLoadingPresentation: state.containers.appReducer.stateLoadingPresentation,   
    slideName: state.containers.appReducer.currentData.slideName,   
    language: state.containers.appReducer.language,
  }
};

export default connect(mapStateToProps)(withStyles(styles,{ withTheme: true })(UploadPresentation));




// WEBPACK FOOTER //
// ./src/containers/scenes/UploadPresentation.js